var mp = mp || {};

// Data Tables
//-----------------------------------------------------------------
mp.dataTabels = function() {

    var $containter = $('#dataTables');
    if (!$containter.length) {
        return;
    }

    $.extend( $.fn.dataTable.defaults, {
    	responsive: true,
    	lengthChange: false,
        pageLength: 20,
        ordering: false,
    });

    $containter.DataTable();
};


// Time Range Selector
//-----------------------------------------------------------------
mp.timePicker = function() {

    var $containter = $('.js_timePicker');
    if (!$containter.length) {
        return;
    }

    var $time = $containter.find(".time");
    var $time_start = $containter.find(".time.start");
    var $time_end = $containter.find(".time.end");

    $time.timepicker({
        'forceRoundTime' : true,
        'show2400' : true,
        'timeFormat': 'H:i',
        'step' : '15',
        'stopScrollPropagation' : true,
    });

    $time_start.timepicker('option', {
        'minTime' : '08:00',
        'maxTime' : '21:45',
    });

    $time_end.timepicker('option', {
        'minTime' : '08:15',
        'maxTime' : '22:00',
    });

    $containter.datepair({
        'defaultTimeDelta' : 900000,
    });
};


// Set Datepicker
//-----------------------------------------------------------------
mp.datePicker = function() {
    var $element = $('.js_datePicker');
    if (!$element.length) {
        return;
    }

    $element.datepicker({
        'format': 'dd.mm.yyyy.',
        'autoclose': true,
        'language': 'hr',
        'orientation': 'bottom',
        'weekStart': '1',
        'daysOfWeekHighlighted': '0,6'
    });
};


// Set Availability Date
//-----------------------------------------------------------------
mp.setAvailabilityDate = function() {
    var $element = $('.js_addAvailability');
    if (!$element.length) {
        return;
    }

    var $form = $('#availability-form');

    $element.on('click', function(){
        $date = $(this).data('date');
        $form.find('#value-date').val($date);
        $form.find('#selected-date').html($date);
    })
};



// Multi select dropdown
//-----------------------------------------------------------------
mp.sumoSelect = function() {
    var $element = $('.sumoSelect');
    if (!$element.length) {
        return;
    }

    $element.SumoSelect({
        placeholder: 'Select',
        nativeOnDevice: [],
    });
};







$(document).ready(function (){
    mp.dataTabels();
    mp.timePicker();
    mp.datePicker();
    mp.setAvailabilityDate();
    mp.sumoSelect();
});